import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicLayout, SectionHeading } from "../components/PublicLayout";
import api from "../lib/api";

export default function MarketingPublic() {
  const [catalog, setCatalog] = useState([]);
  useEffect(() => { api.get("/marketing/catalog").then((r) => setCatalog(r.data)).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="public-marketing-page">
        <SectionHeading
          eyebrow="Marketing Materials"
          title="Print that sells your book"
          sub="Professionally printed banners, bookmarks and flyers — designed around your cover and shipped to your door. Perfect for signings, launches and events."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {catalog.map((p) => (
            <div key={p.id} data-testid={`public-marketing-product-${p.id}`}
              className="bg-white border border-[#E4E4E7] rounded-3xl overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-all flex flex-col">
              <img src={p.image} alt={p.name} className="w-full h-48 object-cover" />
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-semibold font-heading text-lg">{p.name}</h3>
                <p className="text-sm text-[#52525B] mt-2 flex-1 leading-relaxed">{p.desc}</p>
                <p className="text-sm mt-4">from <span className="font-bold font-heading text-2xl">${Math.min(...p.tiers.map((t) => t.price)).toFixed(0)}</span> <span className="text-xs text-[#A1A1AA]">+ shipping</span></p>
                <Link to="/login" data-testid={`public-marketing-order-${p.id}`}
                  className="mt-4 w-full py-2.5 rounded-full text-white bg-[#0A0A0A] hover:bg-[#27272A] text-sm font-medium text-center transition-colors">
                  Sign in to order
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 bg-[#F5F5F7] border border-[#E4E4E7] rounded-3xl p-10 text-center">
          <h3 className="text-2xl font-bold font-heading tracking-tight">Publishing with GloriPub?</h3>
          <p className="text-[#52525B] mt-2 max-w-xl mx-auto">Log in to your author dashboard to configure sizes, materials and quantities — then upload your artwork and we handle the rest.</p>
          <div className="mt-6 flex items-center justify-center gap-3">
            <Link to="/login" data-testid="public-marketing-login" className="px-6 py-2.5 rounded-full text-white bg-[#0A0A0A] hover:bg-[#27272A] text-sm font-medium transition-colors">Log in</Link>
            <Link to="/register" data-testid="public-marketing-register" className="px-6 py-2.5 rounded-full text-sm font-medium border border-[#E4E4E7] hover:bg-white transition-colors">Become an author</Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
